// src/utils/localeCookiesManager.client.ts

export function getLocaleCookie(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(/(?:^|; )locale=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function setLocaleCookie(locale: string) {
  document.cookie = `locale=${encodeURIComponent(locale)}; path=/;`;
}

export function clearLocaleCookie() {
  document.cookie = 'locale=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
}
